import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import cogoToast from 'cogo-toast';
import { adminAPIURL, customHeaders } from '../../../../../../Containers/Config/index.js';
import apiCall from '../../../../apiCall.js';
import { CANCEL_BOOKING_BY_VENDOR, CANCEL_BOOKING_BY_VENDOR_ERROR, CANCEL_BOOKING_BY_VENDOR_SUCCESS } from '../../../actions.js';

function* cancelBookingByVendor({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${adminAPIURL}/v1/vendor/reject-booking`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
      },
      data: {
        ...payload?.body,
      },
    });

    if (response.status === 200) {
      cogoToast.success(response?.data?.message);
      yield put({
        type: CANCEL_BOOKING_BY_VENDOR_SUCCESS,
        payload: response?.data,
      });
    } else {
      cogoToast.error(response?.response?.data?.message);
      yield put({
        type: CANCEL_BOOKING_BY_VENDOR_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: CANCEL_BOOKING_BY_VENDOR_ERROR, payload: error });
  }
}

export function* watchCancelBookingByVendor() {
  yield takeEvery(CANCEL_BOOKING_BY_VENDOR, cancelBookingByVendor);
}

function* cancelBookingByVendorSaga() {
  yield all([fork(watchCancelBookingByVendor)]);
}

export default cancelBookingByVendorSaga;
